import React from 'react';

/**
 * Generic, controlled "metro line" step indicator.
 * @param {{label: string}[]} steps
 * @param {number} currentStep - 0-indexed
 * @param {number} furthestStepReached - 0-indexed, governs which circles are clickable
 * @param {(index: number) => void} onStepClick
 */
const Stepper = ({ steps, currentStep, furthestStepReached, onStepClick }) => {
  const fillPct = steps.length > 1 ? (Math.min(currentStep, furthestStepReached) / (steps.length - 1)) * 100 : 0;

  return (
    <div className="apv2-stepper">
      <div className="apv2-stepper-track">
        <div className="apv2-stepper-track-fill" style={{ width: `${fillPct}%` }} />
        {steps.map((step, index) => {
          const isCurrent = index === currentStep;
          const isDone = index < furthestStepReached;
          const isReachable = index <= furthestStepReached;
          const state = isCurrent ? 'current' : isDone ? 'done' : isReachable ? 'reachable' : 'disabled';

          return (
            <button
              key={index}
              type="button"
              className={`apv2-stepper-circle apv2-stepper-circle--${state}`}
              onClick={() => isReachable && onStepClick(index)}
              disabled={!isReachable}
              aria-current={isCurrent ? 'step' : undefined}
              aria-label={step.label}
              title={step.label}
            >
              {isDone ? (
                <svg width="11" height="9" viewBox="0 0 12 10" fill="none">
                  <path d="M1 5l3.5 3.5L11 1.5" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              ) : (
                index + 1
              )}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default Stepper;
